import React, { useState } from "react";
import KuikaPanelAccordion from "../../../../ui-kit/kuika-panel-accordion/kuika-panel-accordion";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

interface IBodyProps {
  children: React.ReactNode;
}

const Body: React.FC<IBodyProps> = ({ children }: IBodyProps) => (
  <div style={{ padding: "12px 14px", color: "var(--lab-ink-muted)", fontSize: 13 }}>{children}</div>
);

export const PanelAccordionStory: React.FC = (): JSX.Element => {
  const [open1, setOpen1] = useState<boolean>(true);
  const [open2, setOpen2] = useState<boolean>(false);
  const [ticketCount, setTicketCount] = useState<number>(9);

  return (
    <ShowcaseFrame
      title="Panel Accordion"
      componentName="KuikaPanelAccordion"
      sourcePath="ui-kit/kuika-panel-accordion"
      description="Single titled section with a chevron. Its content opens and closes with a grid-row height motion (--dur-base; at once under reduced motion) and is unmounted once closed."
    >
      <SpecRow label="Open / closed" caption="controlled via isOpen prop" align="stretch">
        <div style={{ width: 360 }}>
          <KuikaPanelAccordion label="Position" isOpen={open1} onChange={setOpen1}>
            <Body>Top, left, width, height — sticks to the canvas edges by default.</Body>
          </KuikaPanelAccordion>
          <KuikaPanelAccordion label="Typography" isOpen={open2} onChange={setOpen2}>
            <Body>Font family, size, weight, line-height, letter-spacing.</Body>
          </KuikaPanelAccordion>
        </div>
      </SpecRow>
      <SpecRow
        label="With a count"
        caption="the badge holds a KuikaNumber, so only the digits that change roll"
        align="stretch"
      >
        <div style={{ width: 360 }}>
          <KuikaPanelAccordion label="Open tickets" count={ticketCount}>
            <Body>
              <button type="button" onClick={(): void => setTicketCount((c: number): number => c + 1)}>
                Add one
              </button>{" "}
              <button type="button" onClick={(): void => setTicketCount((c: number): number => Math.max(0, c - 1))}>
                Close one
              </button>
            </Body>
          </KuikaPanelAccordion>
        </div>
      </SpecRow>
      <SpecRow label="Uncontrolled" caption="manages its own state" align="stretch">
        <div style={{ width: 360 }}>
          <KuikaPanelAccordion label="Fill">
            <Body>Backgrounds, gradients and image fills.</Body>
          </KuikaPanelAccordion>
          <KuikaPanelAccordion label="Border">
            <Body>Edges, corner radius, dash patterns.</Body>
          </KuikaPanelAccordion>
          <KuikaPanelAccordion label="Shadow">
            <Body>Drop shadow and inner shadow layers.</Body>
          </KuikaPanelAccordion>
        </div>
      </SpecRow>
    </ShowcaseFrame>
  );
};
